import { render, staticRenderFns } from "./NeedEdit.vue?vue&type=template&id=2d58bde7"
import script from "./NeedEdit.vue?vue&type=script&lang=js"
export * from "./NeedEdit.vue?vue&type=script&lang=js"
import style0 from "./NeedEdit.vue?vue&type=style&index=0&id=2d58bde7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports